
export const PageHeader = () => {
  return (
    <div className="text-center mb-16">
      <h1 className="text-4xl font-bold text-brand-darkgrey mb-6">Meet Our Team</h1>
      <p className="text-lg text-brand-grey max-w-2xl mx-auto">
        We're a team of passionate individuals working together to transform tech hiring in India
      </p>
    </div>
  );
};
